module.exports = __webpack_public_path__ + "static/inside-sauna-41146d41a6d1c58c837e7a0f094e1b08.jpg";